import { useEffect, useState } from "react";

// Helper function to get the user's location

export function useUserLocation() {

    const [userPosition, setUserPosition] = useState(null);

    useEffect(() => {
        // Check if geolocation services are available
        if (!("geolocation" in navigator)) {
            return;
        }

        // Success callback for watchPosition: Setting userPosition
        const success = (pos) => {
            setUserPosition(pos)
        }

        // Error callback for watchPosition: Alert
        const error = () => {
            alert("User position not found.");
        }
        
        // Options object for watchPosition
        const options = {
            enableHighAccuracy: true,   // High position accuracy
            maximumAge: 30000,  // Age until which the position will be reused if it has not changed
            timeout: 27000,     // How long the browser should attempt to get the position for
        };

        const watchID = navigator.geolocation.watchPosition(success, error, options);

        // Cleaning up the user's location
        return () => {
            navigator.geolocation.clearWatch(watchID);
        };

    }, [])

    return { userPosition };

}